import classNames from 'classnames';
import React, { useEffect } from 'react';
import SpectrumV2Provider from '@react/react-spectrum/Provider';
import './ShellSideNav.scss';
import { NavItem } from './NavItem';
import { ThemeContext } from 'context/themeContext';
import { ThemeContextType } from 'types/theme';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserProfile } from 'app/pages/Layout/slice/selectors';

interface Props {
  isOpen: Boolean;
  sideNavConfig: any;
  modal?: any;
  isMultiLevel?: any;
  selectedSideNavItemId: string;
}

export function SideNav(props: Props) {
  const { isOpen, modal, sideNavConfig, isMultiLevel } = props;
  const { theme } = React.useContext(ThemeContext) as ThemeContextType;
  const providerProps = {
    theme: theme === 'darkest' ? 'darkest' : 'light'
  };

  const location = useLocation();

  // Hide sidebar on home page and moment detail pages
  const shouldHideSidebar =
    location.pathname === '/' ||
    location.pathname.startsWith('/moments/') ||
    location.pathname === '/roadmap';

  return (
    <SpectrumV2Provider
      {...providerProps}
      data-testid="shell-side-nav-provider"
    >
      <nav
        className={classNames('shell-sideNav', 'react-spectrum-SideNav', {
          'is-open': isOpen && !shouldHideSidebar,
          'modal-open': modal
        })}
        data-testid="shell-side-nav-navigation"
      >
        <ul
          className={classNames('spectrum-SideNav', {
            'spectrum-SideNav--multiLevel': isMultiLevel
          })}
          data-testid="shell-side-nav-list"
        >
          {sideNavConfig.menu.map((item, index) => {
            return (
              <NavItem
                key={`${item.label}-${index}`}
                item={item}
                data-testid={`shell-side-nav-item-${item.label
                  .replace(/[^a-zA-Z0-9]/g, '-')
                  .toLowerCase()}`}
              />
            );
          })}
        </ul>
      </nav>
    </SpectrumV2Provider>
  );
}
